import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { RadioButtonList } from 'app/components/common/RadioButtonList';
import { Button } from 'app/components/common/Button';
import routes from 'routes';
import { TemplateSelectorModal } from 'app/components/documents/TemplateSelectorModal';
import { TemplateVM } from 'app/stores/ui/template.ui.store';
import { DokumentUploadButton } from 'app/components/documents/DokumentUploadButton';
import { AudioRecordButton } from 'app/components/documents/AudioRecordButton';

export const AgtPlanungNavi = observer(() => {
	const { agtPlanUiStore, agenturUiStore, documentUiStore, uiStore } = useStore();
	const [currentYear, setCurrentYear] = useState(agtPlanUiStore.currentYear);
	const history = useHistory();

	const yearButtons = agtPlanUiStore.planYears.map((y) => {
		return {
			label: y.toString(),
			value: y,
		};
	});


	const onSelect = (val: number | string) => {
		const y = parseInt(val as string);
		setCurrentYear(y);
		history.push(routes.AGENTUR.getPath(agenturUiStore.current!.agtId.toString(), 'planung', y.toString()));
	};

	useEffect(() => {
		setCurrentYear(agtPlanUiStore.currentYear);
	}, [agtPlanUiStore.currentYear]);

	const addDok = (template: TemplateVM) => {
		documentUiStore.addDokumentToPlan(template, agtPlanUiStore.current!.agt, agtPlanUiStore.current!.plan);
	};

	const openExportModal = () => {
		uiStore.showModal(uiStore.modalIds.apExport);
	};

	return (
		<div className="panel-navigation grid is-col-bigger-right">
			<div className="is-left">
				<RadioButtonList includeDefaultClasses={false} buttons={yearButtons} onSelect={onSelect} value={currentYear} classModifier="planung-year-select" />
			</div>
			<div className="is-right">
				<div className="planung-actions">
					{agtPlanUiStore.current && (
						<>
							<TemplateSelectorModal onSelect={addDok} agt={agtPlanUiStore.current.agt} plan={agtPlanUiStore.current.plan} />
							<AudioRecordButton agt={agtPlanUiStore.current.agt} plan={agtPlanUiStore.current.plan} />
							{/* {agtPlanUiStore.currentYear < 2025 && */}
							<Button className="button" onClick={openExportModal}>
								Exportieren
							</Button>
							{/* } */}
							<DokumentUploadButton agt={agtPlanUiStore.current.agt} plan={agtPlanUiStore.current.plan} isButton={true} />
						</>
					)}
				</div>
			</div>
		</div>
	);
});
